import React from 'react'

function Header() {
    return (
        <div className="headerr">
        <h1>Cyclone tracker-powered by NASA  </h1>  
        </div>
    )
}

export default Header
